// extracted by mini-css-extract-plugin
export default {"zoomControls":"Usa-z","zoomControlButton":"Vsa-z","zoomBanner":"Wsa-z","bannerButton":"Xsa-z","imageButton":"Ysa-z"};